module.exports = __webpack_public_path__ + "img/clock4.7aafd973.svg";